"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("@chakra-ui/react");

var _react2 = require("react");

var _jsxRuntime = require("react/jsx-runtime");

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var ContextModal = function ContextModal(props) {
  var _useState = (0, _react2.useState)(props.inputText || ''),
      _useState2 = _slicedToArray(_useState, 2),
      inputText = _useState2[0],
      setInputText = _useState2[1];

  (0, _react2.useEffect)(function () {
    setInputText(props.inputText || '');
  }, [props.inputText]);

  var handleInputChange = function handleInputChange(e) {
    setInputText(e.target.value);
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Modal, {
      isOpen: props.isOpen,
      onClose: props.onClose,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_react.ModalOverlay, {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.ModalContent, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_react.ModalHeader, {
          children: props.title
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.ModalCloseButton, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.ModalBody, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.FormControl, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Input, {
              placeholder: props.inputPlaceholder,
              value: inputText,
              onChange: handleInputChange
            })
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.ModalFooter, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Button, {
            colorScheme: "blue",
            mr: 3,
            onClick: function onClick() {
              return props.onFinish(inputText);
            },
            children: props.finishBtnLabel || 'Save'
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Button, {
            onClick: props.onCancel,
            children: props.cancelBtnLabel || 'Cancel'
          })]
        })]
      })]
    })
  });
};

var _default = ContextModal;
exports["default"] = _default;